// extracted by mini-css-extract-plugin
export default {"withsequenceexample":"eba2d4a3fdaa6d885aae","playbtn":"c7b6b5a33a1a3a52dbbb","arrow":"f8e005f528da3868a34d"};